define('uikit/extra/rendering.manager',['require','exports','module','underscore','./animation.frame.polyfill'],function(require, exports, module){
  var _ = require('underscore');
  require('./animation.frame.polyfill');

  var renderer = {

    queue: [],

    debugging: false,

    ids: [],

    _requested: false,

    // fn is rendering function, and id is unique identifier for this rendering function
    // id is used to make sure that the same rendering function is not called twice.
    requestRender: function(fn, id) {
      if (this.verbose) {
        console.log('view with id', id, 'requesting render');
      }
      if (this.debugging) {
        return fn();
      }
      if (id == null) {
        id = _.uniqueId();
      }
      // check if this rendering function is already queued up
      var index = _.indexOf(renderer.ids, id);
      if (index > -1) {
        // its already queued up somewhere in the queue.
        // lets remove it here, and then next we will
        // re add the rendering function at the top of the queue
        renderer.queue.splice(index, 1);
        renderer.ids.splice(index, 1);
      }

      // add the rendering function and its id to two
      // queues.  it is important that these queues
      // stay in sync (i.e. the index of the id and the fn are the same always)
      renderer.queue.push(fn);
      renderer.ids.push(id);

      // if we haven't issued a request for a drain, do so now
      if (!renderer._requested) {
        // flag signifying that we've requested rendering
        renderer._requested = true;
        window.requestAnimationFrame(renderer.drain);
      }
    },

    drain: function() {
      while (renderer.queue.length) {
        // pop off an id to keep ids and rendering functions in sync
        var id = renderer.ids.shift();

        if (this.verbose) {
          console.log('view with id', id, 'before render');
        }
        // pop off a rendering function and then call it immedietly
        renderer.queue.shift()();

        if (this.verbose) {
          console.log('view with id', id, 'after render');
        }
      }
      // rendering is complete, another request must be called to trigger rendering,
      // so unset the flag
      renderer._requested = false;
    }

  };

  window.__renderingManager = renderer;

  module.exports = renderer;
});

